export type UserSelectionValue = {
  UserId: number,
  Name: string,
  Email: string,
  sfContactId: string, // for old application created before User SfContactId sync this will be undefined
  MobileNumber?: string,
  sfId?: string,
} | null;
